<app-selector label="Character" [data]="characterCoreService.charactersList$| async" displayKey="character" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="characterCoreService.loading" [hint]="hint" [label]="label">
</app-selector>
